var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"part"},[_c('p',{staticClass:"input-filter-label"},[_vm._v(_vm._s(_vm.noteHeadline))]),_c('div',{staticClass:"textarea-wrapper"},[_c('textarea',{staticClass:"textarea",attrs:{"rows":"4","maxlength":"255","placeholder":_vm.noteType},domProps:{"value":_vm.textareaValue},on:{"input":_vm.textareaInput}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }